import once from 'transmute/once';
import IndexedAsyncData from 'conversations-async-data/indexed-async-data/IndexedAsyncData';
export const deferredIndexedAsyncDataSelector = once(() => new IndexedAsyncData());